const translation = {
  toVerifiedTip: {
    end: '用於 Dify 專業計劃。',
    coupon: '獨家 100% 優惠券',
    front: '您現在符合教育驗證狀態的資格。請在下面輸入您的教育資訊以完成此流程並獲得一個',
  },
  form: {
    schoolName: {
      title: '你的學校名稱',
      placeholder: '請輸入您學校的正式全名',
    },
    schoolRole: {
      option: {
        teacher: '老師',
        student: '學生',
        administrator: '校園行政人員',
      },
      title: '你的學校角色',
    },
    terms: {
      desc: {
        and: '和',
        privacyPolicy: '隱私政策',
        termsOfService: '服務條款',
        front: '您的資訊及使用教育驗證狀態需遵循我們的',
        end: '透過提交：',
      },
      option: {
        age: '我確認我至少 18 歲',
        inSchool: '我確認我已在所提供的機構註冊或受僱。Dify 可能會要求提供註冊/就業的證明。如果我錯誤表述我的資格，我同意支付根據我的教育狀況最初免除的任何費用。',
      },
      title: '條款與協議',
    },
  },
  rejectContent: '不幸的是，您不符合教育驗證狀態，因此如果您使用此電子郵件地址，將無法獲得 Dify 專業計劃的 100% 獨家優惠券。',
  successContent: '我們已經向您的帳戶發放了 Dify 專業計劃的 100% 折扣優惠券。該優惠券有效期為一年，請在有效期內使用它。',
  learn: '了解如何進行教育驗證',
  rejectTitle: '您的 Dify 教育驗證已被拒絕',
  submitError: '表單提交失敗。請稍後再試。',
  currentSigned: '當前以以下身份登入',
  emailLabel: '您當前的電子郵件',
  submit: '提交',
  successTitle: '您已獲得 Dify 教育認證',
  toVerified: '獲取教育證明',
}

export default translation
